window.app = window.app || {};

window.app.testimonials = {
  el: document.querySelector('.mt-testimonials__carousel .swiper'),

  init: function() {
    const _this = this;
    if (!_this.el) return;

    _this.slider = new Swiper(_this.el, {
      slidesPerView: 1,
      spaceBetween: -20,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
          centeredSlides: false
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: false
        }
      }
    });
  }
}
window.app.testimonials.init();